import React from 'react';
import styled from 'styled-components';
import ziLoader from 'assets/black-loader-transperent.gif';
import ErrorPage from 'ui/components/ErrorPage';

const sizeMap = {
  small: { width: '50px', height: '50px' },
  medium: { width: '80px', height: '80px' },
  large: { width: '100%', height: '100%' },
};

export const LoaderContainer = styled.div`
  margin: 0;
  position: absolute;
  top: 35%;
  left: 50%;
  transform: translate(-50%, -35%);
  width: ${p => sizeMap[p.size].width};
  height: ${p => sizeMap[p.size].height};

  .zoomloader {
    z-index: 100;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    background-color: transparent;
    display: flex;
    align-items: center;
    justify-content: center;

    .zoomloaderImg {
      background: url(${ziLoader}) no-repeat center center;
      background-size: contain;
      margin: auto;
      max-width: 100px;
      max-height: 100px;
      height: 100%;
      width: 100%;
    }
  }
`;

const PageLoader = React.forwardRef(
  ({ size = 'large', isLoadable, timedOut, pastDelay, error, retry, ...others }, ref) => {
    if (error) {
      return <ErrorPage error={'Unable to load the page'} resetError={retry} />;
    } else if (timedOut) {
      return <ErrorPage error={'Timed out while loading the page'} resetError={retry} />;
    }
    return !isLoadable || (isLoadable && pastDelay) ? (
      <LoaderContainer size={size} innerRef={ref}>
        <div className="zoomloader">
          <div className="zoomloaderImg"></div>
        </div>
      </LoaderContainer>
    ) : null;
  }
);

export default PageLoader;
